export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M20.744 11.371a.5.5 0 0 1 .416.777l-2.879 4.319a.502.502 0 0 0-.084.277v2.972a.5.5 0 0 1-.28.45l-1.817.886a.5.5 0 0 1-.72-.45V16.75a.502.502 0 0 0-.088-.285l-2.986-4.309a.5.5 0 0 1 .41-.785h8.028ZM14 17.278v2.713l-9.001-.011a1 1 0 0 1-.999-1v-1.567a7.146 7.146 0 0 1 5.647-6.985L14 17.278ZM10.82 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z"/>
</svg>
`;
